import { Select } from '@nazka/nazka.mapframe.components'

import './dropdown.styl'

function Dropdown({ searchOptions, value, setValue }) {
  return (
    <>
      <Select
        className="dropdown"
        placeholder="Sort by"
        onInputChange={setValue}
        options={searchOptions}
        value={value}
        width="135px"
      />
    </>
  )
}

export default Dropdown
